import React from 'react'

import classNames from 'classnames'

import { CommonCloseIcon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'
import { BASE_PATH } from '@web/libs/constants'
import links from '@web/libs/constants/links'
import commonLinks from '@web/libs/constants/links/common'
import routes from '@web/libs/constants/routes'
import nClicks from '@web/libs/nlog/click/codes'

import styles from './index.module.scss'

interface Props {
  successCallbackUrl?: string
  failureCallbackUrl?: string
}

const VerifyRealName: ModalComponent<Props> = ({ showModal, cancelModal, successCallbackUrl, failureCallbackUrl }) => {
  const getEncodeURI = (url?: string) => {
    const home = `${links.MY_HOME}${routes.HOME}`

    if (!url) return encodeURIComponent(home)

    if (url.startsWith('/')) {
      url = `${window.location.origin}${BASE_PATH}${url}`
    }

    return encodeURIComponent(url)
  }

  return (
    <ModalContainer showModal={showModal} className={styles.modal_alert}>
      <div className={styles.content_area}>
        <div className={styles.txt_area}>
          <em>실명인증</em>
          된 계정만
          <br />
          플레이스 리뷰어가 될 수 있어요!
        </div>
      </div>
      <div className={styles.btn_area}>
        <Clickable
          className={classNames(styles.btn, styles.type_confirm)}
          href={`${commonLinks.ME_AGREEMENT}?surl=${getEncodeURI(successCallbackUrl)}&rurl=${getEncodeURI(
            failureCallbackUrl,
          )}`}
          nClickCode={nClicks.applyFail.NIDGO}
        >
          실명 인증하러 가기
        </Clickable>
      </div>
      <Clickable className={styles.btn_close} onClick={cancelModal} nClickCode={nClicks.applyFail.NIDOUT}>
        <CommonCloseIcon className={styles.icon} aria-hidden="true" />
        <span className="place_blind">닫기</span>
      </Clickable>
    </ModalContainer>
  )
}
export default VerifyRealName
